export default `#define b(p)length(max(abs(mod(p,.8)-.4)-.05,0.))
    vec3 l;
    p=cos(p)-vec3(.3), p.yx*=mat2(cos(.8+vec4(0.0,3.0,5.0,0.0)));
    return min(min(b(p.xy),b(p.xz)),b(p.yz));
  }`